
export const USER_CONTACT_TYPE = 'USER_CONTACT_TYPE'

export const userContact = (state = null, { type, payload }) => {
  if (type === USER_CONTACT_TYPE) {
    return {
      ...payload,
    }
  }
  return state
}
